export const DIRECT_INQUIRY = {
  positive: "positive",
  mixed: "mixed",
  negative: "negative",
  na: "n/a",
} as const;

export const INDIRECT_INQUIRY = {
  positive: "positive",
  partially_positive: "partially_positive",
  mixed: "mixed",
  neutral: "neutral",
  partially_negative: "partially_negative",
  negative: "negative",
  na: "n/a",
} as const;
